<div class="modal-content">
  <div class="modal-header">
    <h3 class="modal-title">{{title}}</h3>
  </div>
  <div class="modal-body">
    <div class="container my-4">
      <div class="my-3 mx-auto text-center">
        <div *ngIf="message"><h4>{{ message }}</h4></div>
      </div>
      <div class="d-flex justify-content-center">
        <button type="button" class="btn btn-success me-3" id="confirm" (click)="confirm()" *ngIf="confirmButtonTitle">
          <i class="feather icon-check-circle"></i> {{ confirmButtonTitle }}
        </button>
        <button type="button" class="btn btn-danger" id="cancel" (click)="cancel()" *ngIf="cancelButtonTitle">
          <i class="feather icon-x-circle"></i> {{ cancelButtonTitle }}
        </button>
      </div>
    </div>
  </div>
  <!--<div class="modal-footer" style="border-top: 0px; padding-top:0px;">
    <button type="button" class="btn btn-primary" id="confirm" (click)="confirm()" *ngIf="confirmButtonTitle">
      {{ confirmButtonTitle }}
    </button>
    <button type="button" class="btn btn-secondary" id="cancel" (click)="cancel()" *ngIf="cancelButtonTitle">
      {{ cancelButtonTitle }}
    </button>
  </div>-->
</div>
